import React, { useEffect } from 'react';
import { Route } from '@americanexpress/one-app/router';
import PrivacyShell from './PrivacyShell';
const RootRedirect = () => {
  useEffect(() => {
    //! default to US
    const target = '/privacy/#/ipp';
    // Only change if different
    if (window.location.hash !== '#/ipp' || window.location.pathname !== '#/occ') {
      // reload the page with the new URL
      window.location.replace(target);
    }
  }, []);
  return null;
};
const childRoutes = () => [
/*#__PURE__*/
// Main privacy route
React.createElement(Route, {
  key: "privacy",
  path: "/privacy",
  component: PrivacyShell
}), /*#__PURE__*/React.createElement(Route, {
  key: "privacy_country",
  path: "/privacy/:country",
  component: PrivacyShell
}), /*#__PURE__*/React.createElement(Route, {
  key: "root",
  exact: true,
  path: "/",
  component: RootRedirect
})];
export default childRoutes;